<template>
  <div>
    <my-asidebar v-bind:active-tab="'reports'"> </my-asidebar>
    <section class="dashboard-area p-3">
      <top-bar></top-bar>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-box" v-if="sailBookingReportData != null">
              <div class="form-title-wrap">
                <div class="d-flex align-items-center justify-content-between">
                  <h3 class="title">Sail Booking Report</h3>
                </div>
              </div>

              <v-app>
                <v-data-table
                    :headers="headers"
                    :items="sailBookingReportData"
                    :items-per-page="100"
                    class="elevation-1"
                    :search="search"
                    :custom-filter="filter"
                >
                  <!--                  show-group-by-->
                  <template v-slot:top>
                    <v-text-field
                        v-model="search"
                        label="Arama"
                        class="mx-4"/>
                  </template>
                  <template v-slot:item.bookingNumber="{ item }">
                    <tr>
                      {{ item.bookingNumber }}
                    </tr>
                  </template>
                  <template v-slot:item.totalEndorsement="{ item }">
                    <tr>
                      {{ item.totalEndorsement | toCurrency }}
                    </tr>
                  </template>
                  <template v-slot:item.averageAge="{ item }">
                    <tr>
                      {{ item.averageAge.toFixed(2)}}
                    </tr>
                  </template>
                  <template v-slot:item.sailDate="{ item }">
                    <tr>
                      {{ item.sailDate | ddMMyyyy}}
                    </tr>
                  </template>
                </v-data-table>
              </v-app>
            </div>
          </div>
        </div>
<!--        <div class="row">-->
          <div class="col-lg-12 ml-2">
            <div class="row">
              <base-edit-input
                  v-model="email"
                  :rules="'required'"
                  :type="'text'"
                  :label="'Email'">
              </base-edit-input>
              <div class="input-box" style="margin-left: 10px">
                <label>-</label>
                <div class="form-group">
                  <button class="theme-btn" type="button" @click="onSendEmail()">Gönder</button>
                </div>
              </div>
            </div>
<!--          </div>-->
        </div>
    </section>
<!--            </div>-->
</div>
<!--  </div>-->
</template>

<script>
import ReservationStatus from "../component/common/ReservationStatus";
import BaseEditInput from "../component/base/BaseEditInput";
import MyAsidebar from "../component/common/MyAsidebar";
import TopBar from "../component/common/TopBar";
// import generalFunctions from "../util/generalFunctions";

export default {
  name: "CurrentStatusReport",
  components: {TopBar, MyAsidebar, BaseEditInput, ReservationStatus},
  data () {
    return {
      sending : false,
      email: null,
      search: '',
      headers: [
        {
          align: 'start',
          text: 'Kalkış Tarihi',
          sortable: true,
          value: 'sailDate',
        },
        {
          text: 'Sefer Kodu',
          sortable: true,
          value: 'sailId'
        },
        {
          text: 'Paket Adı',
          sortable: true,
          value: 'sailPackageName',
        },
        {
          text: 'Kalkış',
          sortable: true,
          value: 'departurePort',
        },
        {
          text: 'Toplam Kamara',
          sortable: true,
          value: 'totalRoomCount',
        },
        {
          text: 'Satılan Kamara',
          sortable: true,
          value: 'soldRoomCount',
        },
        {
          text: 'Satılan Kamara Yüzdesi',
          sortable: true,
          value: 'soldRoomPercentage',
        },
        {
          text: 'Ciro Total',
          sortable: true,
          value: 'totalEndorsement',
        },
        {
          text: 'PAX',
          sortable: true,
          value: 'pax',
        },
        {
          text: 'Ort Yaş',
          sortable: true,
          value: 'averageAge',
        },
        {
          text: 'Ciro / Kişi',
          sortable: true,
          value: 'endorsementPerPerson',
        },
        {
          text: 'Ciro / Gece',
          sortable: true,
          value: 'endorsementPerNight',
        }
      ]
    }
  },
  computed:{
    sailBookingReportData:{
      get(){
        let sailBookingReportData = this.$store.getters.getSailReportData;
        if(!sailBookingReportData) return null;

        sailBookingReportData.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.sailDate) - new Date(a.sailDate);
        });

        return sailBookingReportData;
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  methods:{
    downloadProforma : function (id){
      this.$store.dispatch("downloadProforma", {id: id});
    },
    onSendEmail(){
      if(!this.sending) {
        this.sending = true;
        this.$store.dispatch("sendSailReport", {email: this.email}).finally(()=>{
          this.sending = false;
        })
        // generalFunctions.ajax("POST", {email: this.email}, "/sail/sendSailReportMail", (response) => {
        //   this.sending = false;
        // })
      }
    },
    filter (value, search, item) {
      if(value == null || search == null){
        return false;
      }

      return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    },
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_CURRENT_STATUS_REPORT"]) this.$router.push("/");

    this.$store.dispatch("loadSailReportData");
  }
}
</script>

<style scoped>

</style>